<!-- <div class="dropdown-container">
  <div class="searchBox mx-2 my-1 py-2 px-2 d-flex">
    <i class="ti ti-search fs-25 mt-1"></i>
    <input
      [(ngModel)]="searchText"
      type="text"
      class="search-input"
      placeholder="Search Practice"
      (input)="onSearch()"
      (focus)="onFocus()"
      style="margin-left: 0.4rem; border: none; outline: none; background: transparent; width: 92% !important;"
    />
  </div>
  <ul
    *ngIf="showDropdown"
    class="dropdown-menu mx-2"
  >
    <li
      *ngFor="let program of filteredPrograms"
      class="dropdown-item"
      (click)="selectProgram(program)"
    >
      {{ program.value }}
    </li>
    <li *ngIf="filteredPrograms.length === 0 && searchText" class="dropdown-item no-results">
      No results found
    </li>
  </ul>
</div> -->
<div class="w-100">
  <app-select
    [items]="programList"
    formName="sidebarSearchForm"
    [formGroup]="sidebarSearchForm"
    formControlValue="sidebarSearch"
    (valueChange)="selectChangedEvent($event)"
  />
</div>
